import { types } from "../types";

const LayoutAction = {
    getLoggedInProfile: () => {
        return { type: types.GET_LOGGEDIN_PROFILE };
    },
    getLoggedInProfileSuccess: (layout) => {
        return { type: types.GET_LOGGEDIN_PROFILE_SUCCESS, layout };
    },
    setMenuHierarchy: (layout) => {
        return { type: types.SET_MENUHIERARCHY, layout };
    },
    setCurrentSite: (layout) => {
        return { type: types.SET_CURRENTSITE, layout };
    },
    setTimeZone: (layout) => {
        return { type: types.SET_TIMEZONE, layout };
    },
    setLandingPage: (layout) => {
        return { type: types.SET_LandingPage, layout };
    },
    setUserDetails: (layout) => {
        return { type: types.SET_UserDetails, layout };
    },
    setMenuCollapse: (layout) => {
        return { type: types.SET_MenuCollapse, layout };
    },
    setDefaultHierarchy: (layout) => {
        return { type: types.GET_DefaultHierarchy, layout };
    },
    setMenuSelection: (menuHierarchy) => {
        return { type: types.SET_MENU_SELECTION, menuHierarchy };
    }
};

export default LayoutAction;
